import * as TYPES from './types';
export default {
    [TYPES.SET_LIST](state, payload) {
        state.listData = payload;
    },
    [TYPES.SET_MAP](state, payload) {
        if(Array.isArray(payload)){
            const {key,value} = payload;
            state.countMap[key] = value;
        }else{
            state.countMap = payload;
        }

    },
};
